import { useCallback, useEffect, useState } from "react";
import { investingApi } from "../../services/api";

// Theses are listed 100 a page; a runaway guard, not a real limit.
const THESIS_PAGES = 10;

/**
 * Every thesis, any status — for a filter, a title beside a slug, or the
 * primary-thesis choice — read page by page to the end.
 *
 * `{theses, loading, error, refresh}`: the list is empty until it lands; a
 * failure leaves it as it was with the error to say so, and `refresh()`
 * (stable) asks again. Only the newest read lands.
 */
function useTheses() {
  const [theses, setTheses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    let live = true;
    setLoading(true);
    setError(null);
    (async () => {
      try {
        const all = [];
        for (let page = 1; page <= THESIS_PAGES; page += 1) {
          const { data } = await investingApi.theses.list({ page });
          all.push(...(data?.results || []));
          if (!data?.next) break;
        }
        if (live) setTheses(all);
      } catch (err) {
        if (live) setError(err);
      } finally {
        if (live) setLoading(false);
      }
    })();
    return () => {
      live = false;
    };
  }, [tick]);

  const refresh = useCallback(() => setTick((t) => t + 1), []);
  return { theses, loading, error, refresh };
}

export default useTheses;
